export { GoIcon } from './go'
